import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SankhyaGatewayService } from '../../services/sankhya-gateway.service';

interface LogisticaItem {
  seq:       number;
  codprod:   number;
  descricao: string;
  refforn?:  string;
  condicao?: string;
  local?:    string;
  unidade:   string;
  qtd:       number;
  conferido: boolean;
}

@Component({
  selector: 'app-estoque-logistica-itens',
  standalone: true,
  imports: [LoadingIndicatorComponent, CommonModule],
  templateUrl: './estoque-logistica-itens.component.html',
  styleUrls: ['./estoque-logistica-itens.component.css']
})
export class EstoqueLogisticaItensComponent implements OnInit {
  @Input() nunota!: number;
  @Output() voltar     = new EventEmitter<void>();
  @Output() finalizado = new EventEmitter<void>();

  itens: LogisticaItem[] = [];
  carregando  = false;
  erro        = '';
  clienteNome = '';
  vendedor    = '';

  // Finalizar
  finalizando     = false;
  erroFinalizar   = '';
  modalFinalizar  = false;

  constructor(private gateway: SankhyaGatewayService) {}

  ngOnInit(): void {
    if (this.nunota) this.carregarItens();
  }

  carregarItens(): void {
    this.carregando = true;
    this.erro = '';
    this.gateway.buscarDetalhesPedidoVenda(this.nunota).subscribe({
      next: (res: any) => {
        const body = res?.responseBody ?? res;
        const det  = body?.detalhe ?? body;
        this.clienteNome = det?.cliente ?? '';
        this.vendedor    = det?.vendedor ?? '';

        const lista = det?.itens ?? [];
        this.itens = lista.map((it: any) => ({
          seq:       it.seq ?? 0,
          codprod:   it.codprod ?? 0,
          descricao: it.descricao ?? '',
          refforn:   it.refforn ?? '',
          condicao:  it.condicao ?? '',
          local:     it.local ?? '',
          unidade:   it.codvol ?? 'UN',
          qtd:       Number(it.qtd ?? 0),
          conferido: false,
        }));
        this.carregando = false;
      },
      error: (err: any) => {
        this.erro = err?.error?.erro ?? err?.message ?? 'Erro ao carregar itens.';
        this.carregando = false;
      }
    });
  }

  onVoltar(): void { this.voltar.emit(); }

  toggleItem(item: LogisticaItem): void {
    item.conferido = !item.conferido;
    if (this.allDone) {
      this.modalFinalizar = true;
    }
  }

  get itensPendentes(): LogisticaItem[] {
    return this.itens.filter(i => !i.conferido);
  }

  get itensConferidos(): LogisticaItem[] {
    return this.itens.filter(i => i.conferido);
  }

  get allDone(): boolean {
    return this.itens.length > 0 && this.itens.every(i => i.conferido);
  }

  get progresso(): number {
    if (!this.itens.length) return 0;
    return Math.round((this.itensConferidos.length / this.itens.length) * 100);
  }

  abaAtiva: 'pendentes' | 'conferidos' = 'pendentes';

  finalizarDoModal(): void {
    this.modalFinalizar = false;
    this.finalizar();
  }

  finalizar(): void {
    if (this.finalizando) return;
    this.finalizando   = true;
    this.erroFinalizar = '';
    this.gateway.confirmarEnvioLogistica(
      this.nunota, 'ITENS', this.itens.length, this.itensConferidos.length
    ).subscribe({
      next: (res: any) => {
        this.finalizando = false;
        if (res?.sucesso) {
          this.finalizado.emit();
        } else {
          this.erroFinalizar = res?.erro ?? 'Erro ao confirmar envio.';
        }
      },
      error: (err: any) => {
        this.finalizando   = false;
        this.erroFinalizar = err?.error?.erro ?? err?.message ?? 'Falha ao confirmar envio.';
      }
    });
  }
}
